export default "__VITE_ASSET__D_ZbEhpP__"